<div class="d-flex justify-content-center">
	<div class="m-2 h1">Please hold while we connect with our partners.</div>
</div>

<div *ngIf="source === 'uber'" class="d-flex flex-column">
	<div class="d-flex">
		<img
			src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
			width="300px"
			height="auto"
			alt="Focus Cloud Logo"
		/>
		<fa-icon [icon]="['far', 'check-double']"></fa-icon>
	</div>
	<div class="d-flex">
		<img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/UberEatsLogo.png" alt="UberEats" width="300px" height="auto" />
		<fa-icon *ngIf="connectionComplete" [icon]="['far', 'check-double']" size="3x"></fa-icon>
	</div>
	<div class="d-flex justify-content-center" *ngIf="!venueSvc.venueKey || venueSvc.venueKey === 0">
		<div class="m-2">
			<h4>Invalid venueKey provided.</h4>
		</div>
	</div>
</div>

<div *ngIf="source === 'quickbooks'" class="d-flex flex-column">
	<div class="d-flex mx-auto">
		<img
			src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
			width="300px"
			height="auto"
			alt="Focus Cloud Logo"
		/>
		<fa-icon [icon]="['far', 'check-double']"></fa-icon>
	</div>
	<div class="d-flex mx-auto">
		<img src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/quick-books-logo-horz.png" alt="Quickbooks Logo" width="300px" height="auto" />
		<fa-icon *ngIf="connectionComplete" [icon]="['far', 'check-double']" size="3x"></fa-icon>
	</div>
</div>

<div class="d-flex flex-column" *ngIf="connectionComplete">
	<div class="mx-auto h2">Connection complete.</div>
	<div class="mx-auto h4">You may now close this tab.</div>
</div>
